<template>
    <div class="form-item">
        <label class="label-caption">Produto</label>
        <select :value="objSelecionado?.id" @change="atualizarObj" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.nmproduto }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const props = defineProps({
    ckAddTodos:{type: Boolean, default: false},
    ckMp:{type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    ckProducao: {type: Boolean, default: false},
    idAtividade: {type: Number, default: 0},
    modelValue: { type: Object, default: null }
});

const emit = defineEmits(["update:modelValue"]);

const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await genericPost('/listas/produtos', {
            idep: globalStore.idep, 
            idatividade: props.idAtividade,
            intparam1: props.ckMp ? 1 : 0,
            intparam2: props.ckProducao ? 1 : 0,
            ativo: 'S'});
        lsDados.value = response;
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmproduto: 'TODOS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;} 
};

const atualizarObj = (event) => {
    const id = Number(event.target.value);
    const selecionado = lsDados.value.find(obj => obj.id === id) || null;
    emit("update:modelValue", selecionado);
};

const objSelecionado = computed(() =>
    props.modelValue && props.modelValue.id != null
        ? props.modelValue
        : null
);

onMounted(() => {
    if (props.ckPesquisar){fetchData();}
});

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
);
</script>